import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import * as actions from '../../store/actions/index';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import Paper from '@material-ui/core/Paper';
import 'react-pdf/dist/Page/AnnotationLayer.css';
import CircularProgress from '@material-ui/core/CircularProgress';
import List from '@material-ui/core/List';
import { Document, Page, pdfjs } from 'react-pdf';
import withSizes from 'react-sizes';
import PDF from '../Onboarding/PDF'
import leftIcon from '../../images/left.png'
import Button from "@material-ui/core/Button";
import UploadDocsSingleFile from '../../containers/Onboarding/UploadDocsSingleFile'
import PropTypes from "prop-types";

import Iframe from 'react-iframe'
pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

const styles = theme => ({
    textColor: {
        color: '#a52423'
    },
    divStyle: {
        paddingLeft: '5%',
        // paddingTop: '30px',
        // paddingRight: '340px',
        // paddingBottom: '70px',
        // // border: 'none'
        // align:'center',
        // textAlign: 'center'

    },
    padding: {
        padding: '30px'
    },
    subText: {
        color: '#a52423',
    },
    container:{
        align:'center',
        textAlign: 'center'
    },
    paper:{
        align:'center',
        textAlign: 'center',
        // marginTop: '20vh',
        color:'#a52423'
    }
});

class Response extends Component {

    state = {
        numPages: null,
        pageNumber: 1,
        isLoading: true,
        typeOfAccount:localStorage.getItem('typeOfAccount'),
    }

    onDocumentLoadSuccess = ({ numPages }) => {
        this.setState({ numPages });
    }

    componentWillUpdate() {

    }

    componentDidMount() {
        // this.props.getCaseInfo(this.props.match.params.id);
        setTimeout(()=>{
            this.setState({
                isLoading: false
            })
        },5000)
    }

    render() {

        const { classes, file } = this.props;
        let { numPages, pageNumber } = this.state;
        let fileDocURL = `${process.env.REACT_APP_SERVER_HOSTNAME}:9000/getDoc/?id=${this.props.conversationId}_response`;

        if (this.state.isLoading) {
            return(<CircularProgress size={50} thickness={3} className={classes.progress}/>);
          }
        else{
            console.log(`FM Response ${this.props.caseData.respondent_signature}`)
            const keys = Object.keys(this.props.caseData)
            let sigs = false
            for(const k of keys){
                console.log(k +' '+k.includes('_respondent_signature_'))
                
                if (k.includes('respondent_signature_')){
                    sigs = true
                }
            }
            if (this.props.caseData.respondent_signature !== undefined || sigs){
                if (this.props.respondent_steps_completed.chatbot == true){
                    let fileURL = `${process.env.REACT_APP_SERVER_HOSTNAME}:9000/getPdf/?id=${this.props.conversationId}_response`;
                    let fileURLNoName = `${process.env.REACT_APP_SERVER_HOSTNAME}:9000/getPdf/?id=${this.props.conversationId}_response`;
                    return (
                    <div style={{ marginBottom:'40%' }}>
                        <Button onClick={(e)=>{this.props.handleChange(e, undefined)}} style={{textAlign:'left'}}><img style={{width:'15%', marginRight:'10px'}} src={leftIcon}></img>{this.context.t("Back")}</Button>
                        <PDF fileURLNoName={fileURLNoName} isDesktop={this.props.isMobile} file = {fileURL} wordFile={fileDocURL} ></PDF>
                    </div>
                    );
                }
                else{
                    return (
                        <div className={classes.divStyle}>
                            <Button onClick={(e)=>{this.props.handleChange(e, undefined)}} style={{textAlign:'left'}}><img style={{width:'15%', marginRight:'10px'}} src={leftIcon}></img>{this.context.t("Back")}</Button>
                            <h4 className={classes.paper}> {this.context.t('The respondent has not yet responded.')} </h4>
                        </div>
                    );
                }
            }
            else{
                return (
                    <div className={classes.divStyle}>
                        <Button onClick={(e)=>{this.props.handleChange(e, undefined)}} style={{textAlign:'left'}}><img style={{width:'15%', marginRight:'10px'}} src={leftIcon}></img>{this.context.t("Back")}</Button>
                        <h4 className={classes.paper}> {this.context.t('The respondent has not yet responded.')} </h4>
                    </div>
                );
            }
        }
    }
}


const mapStateToProps = (state) => {
    // console.log('mapStateToProps: state: ' + JSON.stringify(state));
    return {
        respondent_steps_completed: state.caseInfo.respondent_steps_completed,
        error: state.caseInfo.error,
        conversationId: state.caseInfo.conversationId,
        caseId: state.caseInfo.caseId,
        caseData: state.caseInfo.caseData
    }
}

const mapSizesToProps = sizes => ({
    isMobile: withSizes.isMobile(sizes),
    isTablet : withSizes.isTablet(sizes),
    isDesktop : withSizes.isDesktop(sizes),
    isGtMobile : withSizes.isGtMobile(sizes),
    isGtTablet : withSizes.isGtTablet(sizes),
    isStTablet : withSizes.isStTablet(sizes),
    isStDesktop : withSizes.isStDesktop(sizes),
    isTabletAndGreater : withSizes.isTabletAndGreater(sizes),
    isTabletAndSmaller : withSizes.isTabletAndSmaller(sizes),

})

const mapDispatchToProps = (dispatch) => {
    return {
        getCaseInfo: (caseId) => dispatch(actions.getCaseInfo(caseId)),
    }
}

Response.contextTypes = {
    t: PropTypes.func
  }

export default withStyles(styles)(connect(mapStateToProps, mapDispatchToProps)(withSizes(mapSizesToProps) (withRouter(Response))) );